import clsx from 'clsx';

type Props = {
  pageNumber: number;
  active: boolean;
  inverse: boolean;
  onClick: (page: number) => void;
};

const PageNumber = ({ pageNumber, active, inverse, onClick }: Props) => {
  return (
    <button
      className={`h-[36px] w-[36px] rounded-4 text-md focus-visible:rounded-4 ${clsx({
        'bg-white-100 text-primary-inverse-slate-grey': active && inverse,
        'bg-secondary-turquoise text-white-100': active && !inverse,
        'text-white-100': !active && inverse,
        'text-monochrome-6': !active && !inverse,
      })}`}
      onClick={() => onClick(pageNumber)}
    >
      {pageNumber}
    </button>
  );
};
export default PageNumber;
